import { render, staticRenderFns } from "./Consultant.vue?vue&type=template&id=1720e8df&scoped=true&"
import script from "./Consultant.vue?vue&type=script&lang=js&"
export * from "./Consultant.vue?vue&type=script&lang=js&"
import style0 from "./Consultant.vue?vue&type=style&index=0&id=1720e8df&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1720e8df",
  null
  
)

export default component.exports